import dayjs from "dayjs";
import type { Vehicle } from "../Vehicle";
import { type AppointmentType, AppointmentState, type IAppointment, type IAppointmentDto, type PickupAndDeliveryState } from ".";

export class Appointment implements IAppointment
{

    appointmentId: string;
    title?: string;
    businessConsumerId: string;
    vehicleId?: string;
    firstName: string;
    lastName: string;
    withName?: string;
    utcDateCreated: string;
    utcDateAppointment?: string;
    appointmentType: AppointmentType;
    appointmentState: AppointmentState;
    pickupAndDeliveryState: PickupAndDeliveryState;
    paid: number;
    owing: number;

    age: number;
    vehicle?: Vehicle;
    isOffered: boolean; // the appointment has been offered
    isBooked: boolean; // the appointment has been made (it's not an offer)
    isOpen: boolean; // the appointment is booked and hasn't been completed, missed or cancelled

    constructor( model: IAppointmentDto, vehicle?: Vehicle )
    {

        this.appointmentId = model.appointmentId;
        this.businessConsumerId = model.businessConsumerId;
        this.vehicleId = model.vehicleId;
        this.title = model.title;
        this.firstName = model.firstName;
        this.lastName = model.lastName;
        this.withName = model.withName;
        this.utcDateCreated = model.utcDateCreated;
        this.utcDateAppointment = model.utcDateAppointment;
        this.appointmentType = model.appointmentType;
        this.appointmentState = model.appointmentState;
        this.pickupAndDeliveryState = model.pickupAndDeliveryState;
        this.paid = model.paid;
        this.owing = model.owing;

        this.age = dayjs().diff( dayjs( this.utcDateCreated ), 'days' );
        this.isOffered = this.appointmentState == AppointmentState.Offered;
        this.isBooked = this.appointmentState >= AppointmentState.Booked;
        this.isOpen = this.isBooked && this.appointmentState <= AppointmentState.Missed;

        // TODO: This may need to become an API call because the appointment
        //  could be for a car that the consumer doesnt currently own, or a loan car, etc.
        this.vehicle = vehicle;

    }

    /**
     * True if the appointment has a vehicle attached
     */
    get hasVehicle()
    {
        return this.vehicle != null;
    }

    /**
     * Gets the appointment consumers display name
     */
    get displayName()
    {
        return `${ this.firstName ?? '' } ${ this.lastName ?? '' }`.trim();
    }

}
